import { useEffect, useState } from "react";

const navLinks = [
  { label: "官方认证", href: "#trust" },
  { label: "官方快讯", href: "#news" },
  { label: "栏目导览", href: "#channels" },
  { label: "进入指南", href: "#guide" },
  { label: "防伪识别", href: "#fake" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "sticky top-0 z-50 w-full transition-colors duration-300 border-b " +
        (scrolled
          ? "bg-background-50/90 backdrop-blur border-background-200/80"
          : "bg-background-50/40 border-transparent")
      }
    >
      {/* 顶部细提示条 */}
      <div className="bg-foreground-950 text-background-50">
        <p className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-4 py-1.5 text-center text-xs md:text-sm">
          <i className="ri-vip-crown-2-line text-accent-300 text-sm"></i>
          <span>认准唯一认证标识 · 谨防仿冒入口</span>
          <span className="hidden sm:inline text-background-300">｜</span>
          <a href="#trust" className="hidden underline-offset-4 hover:underline sm:inline text-accent-200">
            了解官方认证 →
          </a>
        </p>
      </div>

      <nav className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-water-flash-fill text-xl"></i>
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-foreground-950">
            吃瓜官网<span className="ml-1 inline-block rounded-sm bg-accent-100 px-1.5 py-0.5 text-[11px] font-medium text-accent-800">官方</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="block whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-2 lg:flex">
          <span className="flex items-center gap-1.5 rounded-full border border-accent-300 bg-accent-50 px-3 py-1.5 text-xs font-medium text-accent-800">
            <i className="ri-verified-badge-fill text-accent-500"></i>
            唯一认证
          </span>
          <a
            href="#guide"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            直达官方地址
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 lg:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto max-w-6xl px-4 py-3">
            <ul className="grid grid-cols-2 gap-1">
              {navLinks.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={() => setOpen(false)}
                    className="block rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href="#guide"
              onClick={() => setOpen(false)}
              className="mt-3 flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              直达官方地址
            </a>
          </div>
        </div>
      )}
    </header>
  );
}